export enum MergeFieldFormInputTypes {
    date = 'date',
    dropdown = 'dropdown',
    text = 'text',
    number = 'number',
}
